export function handleWithMileDot() {
    const target = this;
    if (!Truthy(this))
        return undefined;
    return target?.toLocaleString('pt-br');
}
//# sourceMappingURL=handleWithMileDot.js.map